import { render } from "./UNL.vue?vue&type=template&id=3cf8c1cc"
import script from "./UNL.vue?vue&type=script&lang=js"
export * from "./UNL.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__